module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "info-box"
  }, [_c('ul', {
    staticClass: "timeline"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.manualsInstructive), function(manual) {
    return _c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
    }, [_c('a', {
      staticClass: "progress-description",
      staticStyle: {
        "color": "#FFF"
      },
      attrs: {
        "href": manual.path,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "background-color": "#909090"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "max-height": "90px"
      }
    }, [_c('span', {
      staticClass: "info-box-number",
      staticStyle: {
        "white-space": "pre-line",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(manual.name))])])])])])
  }), 0)])])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "timeline-item col-md-10"
  }, [_c('div', {
    staticClass: "timeline-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.manualsNorms), function(manual) {
    return _c('div', {
      staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
    }, [_c('a', {
      staticClass: "progress-description",
      staticStyle: {
        "color": "#FFF"
      },
      attrs: {
        "href": manual.path,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "background-color": "#909090"
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "max-height": "90px"
      }
    }, [_c('span', {
      staticClass: "info-box-number",
      staticStyle: {
        "white-space": "pre-line",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(manual.name))])])])])])
  }), 0)])])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-green"
  }, [_vm._v("Instructivo del Portal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "time-label"
  }, [_c('span', {
    staticClass: "bg-red"
  }, [_vm._v("Normas y Procedimientos para Proveedores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bcb2406"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Manuals.vue
// module id = 616
// module chunks = 1